import React, {Component} from "react";
import {
    Platform,
    View,
    ScrollView,
    TouchableOpacity,
    KeyboardAvoidingView,
    ActivityIndicator,
} from "react-native";


import {moderateScale} from '../../../../tools/Scaling';


import HMActionBar from "../../../../customviews/HMActionBar";


import i18n from '../../../../I18n/i18n.js';

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from "../../../../redux/NavigationService";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import {Tools} from "../../../../tools/Tools";
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";
import HMImageView from "../../../../customviews/HMImageView";
import PathFile from "../../../../assets/PathFile";
import {typeExport} from "../../../../redux/store/type";

import HMLoading from "../../../../customviews/HMLoading";

import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import store from "../../../../redux/store";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import {DialogUpdateAppCustomize} from "../../../../customviews/dialogUpdateApp/DialogUpdateAppCustomize";
import HMAlert from "../../../../customviews/HMAlert";

let container = null;
let countTest = 0;


import {callWebservice as callWebserviceSplash} from "../../splash/action/ActionSplashGetAllData";
import HMIcon from "../../../../customviews/HMIcon";


export default class ApplyScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        let viewportWidth = 1;
        let viewportHeight = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.documentElement.clientWidth;
            viewportHeight = document.documentElement.clientHeight;


        }
        // switch (Platform.OS) {
        //
        //     case "android":
        //         firebase = require("react-native-firebase")
        //
        //         break;
        //     default:
        //
        // }
        // if (Platform.OS === "android") {
        //      firebase = require("react-native-firebase")
        //
        // }
        this.state = {
            checkCountRequest: 0,
            columnCount: 2,
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            alaki: false,
            viewportWidth: viewportWidth,
            viewportHeight: viewportHeight,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
        };


    }

    async getDataServerSplash() {
        this.setState({
            checkCountRequest: this.state.checkCountRequest + 1
        })
        let dataSplash = this.props.DataSplashScreen;
        if (store.getState().reducerSplashGetAllData.token && (dataSplash.TypeLogin == 2 || dataSplash.TypeLogin == 1 || dataSplash.TypeLogin == null)) {

            let paramss = {
                "token": dataSplash.token,
                "id": 1,
                "lang": i18n.locale,
                "imei": 0,
                'token_mahale': dataSplash.tokenMahaleh,
                //  'tenant_id': store.getState().reducerSplashGetAllData?.City?.tenant_id,

                "token_fb": dataSplash.token_fb,
            };
            paramss = Tools.addAllParams(paramss);

            if (dataSplash.Connection) {

                if (global.GoOfflineToMain || !(this.props.DataSplashScreen.results))

                    if ((global._loadDataCount && global._loadDataCount > 0) || (global.GoOfflineToMain || !(dataSplash.TypeLogin == 2 ? dataSplash.resultsShahrdar : dataSplash.results))) {
                        if (dataSplash.TypeLogin == 2)
                            store.dispatch(callWebserviceSplash(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))
                        else {
                            store.dispatch(callWebserviceSplash(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))

                        }
                        //  this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, token, token_fb, imageBack);

                    }
                    else
                        global._loadDataCount = global._loadDataCount ? global._loadDataCount + 1 : 1;


                await AsyngStorageClass.setAsyng("splash" + global.IdCity, dataSplash.results);

                if (dataSplash.TypeLogin == 2)
                    await AsyngStorageClass.setAsyng("splashShahrdar" + global.IdCity, dataSplash.resultsShahrdar);
                else
                    await AsyngStorageClass.setAsyng("splashSaina" + global.IdCity, dataSplash.resultsSaina);

            }
            else {
                if (dataSplash.TypeLogin == 2)
                    store.dispatch(callWebserviceSplash(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))
                else {
                    store.dispatch(callWebserviceSplash(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))

                }
            }
        }

    }

    async componentDidMount() {

        let OrganCity = this.props.DataSplashScreen?.OrganCity;
        let user = this.props.DataSplashScreen?.user;
        let _params = this.props.route.params;
        let item = _params ? JSON.parse(_params.item) : null;

        if (item.type != "7") {
            if (!Tools.CheckValue(OrganCity) && (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") && user && user.orgs) {
                this.setState({
                        checkCountRequest: this.state.checkCountRequest + 1
                    },
                    () => {

                    }
                )
                NavigationService.navigateParams("ListCityScreen", {type: "orgs"});

            }
            else {
                //  if (this.props.DataSplashScreen.TypeLogin == 2 && (typeExport._NameApp == "MahalemaArak"))
                let result = (this.props?.route?.key?.toString());
                //   if (this.props.DataSplashScreen.TypeLogin == 2 && (result.search('ApplyScreen-') >= 0) && (item?.typepm == "mahale" ? true : !(item?.type == 7)) &&(typeExport._NameApp!=="MahalemaArak"))
                if (this.props.DataSplashScreen.TypeLogin == 2 && (result.search('ApplyScreen-') >= 0) && (item?.typepm == "mahale" ? true : !(item?.type == 7)))
                    this.getDataServerSplash();
            }
        }


        this.props.callServiceRefresh();

        this.props.navigation.addListener('focus', () => {

                let OrganCity = this.props.DataSplashScreen?.OrganCity;
                let user = this.props.DataSplashScreen?.user;
                //
                // if (!Tools.CheckValue(OrganCity)){
                //     NavigationService.Pop();
                // }

                this.setState({
                    alaki: !this.state.alaki,
                })
                container = this;
                if (item.type != "7") {
                    if (this.state.checkCountRequest > 0) {

                        if (!Tools.CheckValue(OrganCity) && (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") && user && user.orgs) {
                            // NavigationService.navigateParams("ListCityScreen");
                            NavigationService.Pop();

                        }
                        else {// if (this.props.DataSplashScreen.TypeLogin == 2 && (typeExport._NameApp == "MahalemaArak"))
                            if (this.props.DataSplashScreen.TypeLogin == 2 && (this.props.route.key.search('ApplyScreen-') >= 0) && (typeExport._NameApp !== "MahalemaArak"))
                                this.getDataServerSplash();
                        }

                    }
                }
            }
        )
        this.props.navigation.addListener('blur', () => {
        })

        let {resultsShahrdar} = store.getState().reducerSplashGetAllData;
        global.list_menu_shahrdar = resultsShahrdar && resultsShahrdar.result.menu;


        // global.ref_toast.current.show({
        //     text1: 'Hello',
        //     text2: 'This is some something 👋'
        // })
        // Toast.show({
        //     text1: 'Hello',
        //     text2: 'This is some something 👋'
        // });

        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.documentElement.clientWidth;
                let viewportHeight = document.documentElement.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        viewportHeight: viewportHeight,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 600 ? 4 : 2,
                    },
                )


            })
        /*  if (Platform.OS === "android") {
              const channel = new firebase.notifications.Android.Channel(
                  '1',
                  'A',
                  firebase.notifications.Android.Importance.Max
              ).setDescription('A natural description of the channel');
              firebase.notifications().android.createChannel(channel);

              // the listener returns a function you can use to unsubscribe
              this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                  if (Platform.OS === 'android') {
                      const localNotification = new firebase.notifications.Notification({
                          sound: 'default',
                          show_in_foreground: true,
                      }).setNotificationId(notification.notificationId)
                          .setTitle(notification.title)
                          .setSubtitle(notification.subtitle)
                          .setBody(notification.body)
                          .setData(notification.data)
                          .android.setChannelId('channelId') // e.g. the id you chose above
                          .android.setSmallIcon('logo') // create this icon in Android Studio
                          .android.setLargeIcon('logo') // create this icon in Android Studio
                          // .android.setColor('#ee3d43') // you can set a color here
                          .android.setPriority(firebase.notifications.Android.Priority.High);

                      firebase.notifications()
                          .displayNotification(localNotification)
                          .catch(err => console.error(err));

                  }
                  else if (Platform.OS === 'ios') {

                      const localNotification = new firebase.notifications.Notification()
                          .setNotificationId(notification.notificationId)
                          .setTitle(notification.title)
                          .setSubtitle(notification.subtitle)
                          .setBody(notification.body)
                          .setData(notification.data)
                          .ios.setBadge(notification.ios.badge);

                      firebase.notifications()
                          .displayNotification(localNotification)
                          .catch(err => console.error(err));
                  }


                  if (notification && notification.data && notification.data.typeOperation === '1') {
                      let item = null

                      if (notification.data.menu) {
                          item = JSON.parse(notification.data.menu.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())

                          if (item.length > 0) {
                              global.list_menu_shahrdar = item;
                              this.setState({alaki: !this.state.alaki})

                          }
                      }
                  }

              });
              // if (store.getState().reducerSplashGetAllData.TypeLogin == 2)
              //     this.getData()

          }*/
        this.unsubscribeFromNotificationListener = Tools.receiveonOnNotification(this.changeMenu)

    }

    changeMenu() {
        container.setState({alaki: !container.state.alaki})
    }

    getData() {
        let {mobile, password} = this.state;

        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": typeExport._GetCalendar,
            "lang": i18n.locale,

            //    "username": mobile,
            //  "password": password,
            //
            // "username": Tools.persianToEnglish(mobile),
            // "password": Tools.persianToEnglish(password),
            // "token_fb": this.props.DataSplashScreen.token_fb,
        };

        this.props.callService(
            typeExport.urlApplyScreen,
            paramss,
            typeExport.TypeGetApplyScreen,
            "POST",
            this.state
        );

    }

    componentWillUnmount() {

        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener();
        }
    }

    render() {
        let {viewportWidth, viewportHeight} = this.state;

        let list = this.props.route.params ? this.props.route.params.list : null;
        let request_server = this.props.route.params ? this.props.route.params.request_server : null;
        // let item = this.props.route.params ? this.props.route.params.item : null;
        let _params = this.props.route.params;
        let item = _params ? JSON.parse(_params.item) : null;
        let {resultsShahrdar, user} = store.getState().reducerSplashGetAllData;
        let OrganCity = user && user.orgs ? this.props.DataSplashScreen?.OrganCity : null;

        let type = this.props.route.params ? this.props.route.params.type : null;

        let checkLogin = store.getState().reducerSplashGetAllData.token && (store.getState().reducerSplashGetAllData.TypeLogin == 2 || typeExport._NameApp == "MahalemaArak");

        let dataList = checkLogin && (item?.typepm == "mahale" ? true : !(item?.type == 7)) ?
            (type === "report" ?
                    (item && item.list ? item.list
                        : [
                            {
                                name: 'درخواستهای پر تکرار',
                                //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                //image_source:  PathFile.image.sabt_darkhast,
                                image_source: PathFile.image.darkhast15,
                                type: 1,
                            },
                            {
                                name: 'وضعیت درخواست ها',
                                //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                // image_source: PathFile.image.Natije_Darkhast,
                                image_source: PathFile.image.darkhastha,
                                type: 2,
                            },

                            /*  {
                                  name: 'معوقه ها',
                                  //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                  // image_source: PathFile.image.Natije_Darkhast,
                                  svg: PathFile.image.darkhastha,
                                  type: 5,
                              },*/

                        ])
                    :
                    (resultsShahrdar && resultsShahrdar.result.menu ? global.list_menu_shahrdar : global.list_menu_shahrdar)
            )
            :
            (typeExport._NameApp == "Arak" || typeExport._NameApp == "Cloud" || typeExport._NameApp == "CloudTest" ?
                    (
                        (typeExport._NameApp == "Cloud" || typeExport._NameApp == "CloudTest") && (item?.typepm == "mahale" ? true : (item?.type == 7)) ?
                            [
                                {
                                    name: 'ثبت درخواست',
                                    //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                    //image_source:  PathFile.image.sabt_darkhast,
                                    image_source: (PathFile.image.sabt_darkhast),
                                    typeClick: 1,
                                    type: 7,
                                    typeParent: 5,
                                    NoLogin: true,
                                },
                                {
                                    name: 'مشاهده نتیجه درخواست',
                                    //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                    // image_source: PathFile.image.Natije_Darkhast,
                                    image_source: (PathFile.image.Natije_Darkhast),
                                    type: 7,
                                    typeClick: 2,
                                    typeParent: 5,
                                    NoLogin: true,
                                },
                                {
                                    name: 'پیام به بازرسی',
                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                    //image_source: PathFile.image.Sabt_Shekayat,
                                    image_source: (PathFile.image.Sabt_Shekayat),

                                    typeClick: 3,
                                    type: 7,
                                    NoLogin: true,
                                },
                                {
                                    name: 'مشاهده نتیجه بازرسی',
                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                    image_source: (PathFile.image.Natije_Shekayat),

                                    // image_source: PathFile.image.Natije_Shekayat,
                                    typeClick: 4,
                                    type: 7,
                                    NoLogin: true,
                                },

                            ]
                            :
                            [
                                {
                                    name: 'ثبت درخواست',
                                    //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                    //image_source:  PathFile.image.sabt_darkhast,
                                    image_source: (PathFile.image.sabt_darkhast),
                                    typeClick: 1,
                                },
                                {
                                    name: 'مشاهده نتیجه درخواست',
                                    //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                    // image_source: PathFile.image.Natije_Darkhast,
                                    image_source: (PathFile.image.Natije_Darkhast),

                                    typeClick: 2,
                                },
                                {
                                    name: 'پیام به بازرسی',
                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                    //image_source: PathFile.image.Sabt_Shekayat,
                                    image_source: (PathFile.image.Sabt_Shekayat),

                                    typeClick: 3,
                                    type: 7
                                },
                                {
                                    name: 'مشاهده نتیجه بازرسی',
                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                    image_source: (PathFile.image.Natije_Shekayat),

                                    // image_source: PathFile.image.Natije_Shekayat,
                                    typeClick: 4,
                                    type: 7
                                },
                                // 1 === 1 ? {
                                //     name: 'کارتابل',
                                //     //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                //     image: PathFile.image.Natije_Shekayat,
                                //     typeClick: 5,
                                //     type: 7
                                // } : null
                                // ,
                            ]
                    )
                    :
                    [
                        {
                            name: 'ثبت درخواست',
                            //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                            //  image_source: PathFile.image.sabt_darkhast,
                            image_source: (PathFile.image.sabt_darkhast),

                            typeClick: 1,
                        },
                        {
                            name: 'مشاهده نتیجه درخواست',
                            //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                            //  image_source: PathFile.image.Natije_Darkhast,
                            image_source: (PathFile.image.Natije_Darkhast),

                            typeClick: 2,

                        },

                    ]
            );

        /*       if (countTest === 0) {
                   countTest = 1;
                   dataList.push({
                       name: 'پیام های مدیران',
                       //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                       //image_source:  PathFile.image.sabt_darkhast,
                       image_source: PathFile.image.darkhast15,
                       svg: "https://app.iran137.com/images/svg/settings.svg",
                       type: 6,
                       list: [
                           {
                               name: 'ویرایش نقش ها',
                               //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                               //image_source:  PathFile.image.sabt_darkhast,
                               image_source: PathFile.image.darkhast15,
                               svg: "https://app.iran137.com/images/svg/role.svg",
                               type: "d_1",
                           },
                           {
                               name: 'ویرایش الگوی مشاهده داشبورد',
                               //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                               // image_source: PathFile.image.Natije_Darkhast,
                               image_source: PathFile.image.darkhast15,
                               svg: "https://app.iran137.com/images/svg/dashbord.svg",

                               type: "d_2",
                           },

                       ]
                   })
                   dataList.push({
                       name: 'داشبورد عملکرد',
                       //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                       //image_source:  PathFile.image.sabt_darkhast,
                       image_source: PathFile.image.darkhast15,
                       svg: "https://app.iran137.com/images/svg/speedometer.svg",
                       type: 9,

                   })
               }*/

        const aspect = viewportWidth / viewportHeight;

        const adjustedHeight = Math.ceil(viewportWidth / aspect) / (Platform.OS === "web" ? 2.6 : 1.6);
        /*
        *  <svg width="${viewportWidth * 1.4}" height="${adjustedHeight}" viewBox="0 0 ${viewportWidth * (Platform.OS === "web" ? 1.6 : 1.4)} ${adjustedHeight}"  preserveAspectRatio={"xMinYMin slice"} version="1.1" xmlns="http://www.w3.org/2000/svg">
*/
        const xml = `
 <svg width="802pt" height="302pt" viewBox="0 0 400 800" version="1.1" xmlns="http://www.w3.org/2000/svg">
<g id="svgg" transform="scale(0.7)">
    <path id="path0" fill="#0b8233" opacity="1.00" d=" M 333.16 208.02 C 339.78 208.14 346.39 208.70 353.01 208.93 C 353.54 209.22 354.61 209.80 355.15 210.09 C 356.09 210.33 357.04 210.57 358.00 210.81 C 358.53 211.12 359.59 211.75 360.12 212.07 C 362.92 213.05 365.84 212.68 368.64 211.88 C 385.60 220.30 403.09 227.62 420.15 235.82 C 429.36 240.43 439.02 244.05 448.27 248.59 C 450.50 249.60 452.77 250.54 455.05 251.46 C 454.49 253.83 453.95 256.34 452.08 258.06 C 448.97 261.15 446.45 264.78 444.71 268.81 C 447.67 269.99 450.56 271.33 453.53 272.50 C 457.01 274.07 460.92 272.90 464.56 273.62 C 467.34 274.45 469.71 276.20 472.13 277.76 C 472.53 277.72 473.34 277.63 473.74 277.59 C 475.24 279.00 476.74 280.42 478.24 281.84 C 479.46 281.74 480.68 281.65 481.91 281.56 C 482.73 282.62 483.57 283.69 484.42 284.75 C 483.71 289.47 482.65 294.14 482.24 298.91 C 488.66 296.13 494.24 291.82 500.01 287.94 C 500.91 288.23 501.81 288.52 502.72 288.82 C 508.51 284.86 514.25 280.81 520.28 277.23 C 529.50 272.84 538.83 268.60 548.33 264.83 C 549.59 264.48 550.85 264.14 552.13 263.84 C 552.54 263.88 553.34 263.97 553.74 264.02 C 554.91 264.63 556.01 265.38 557.15 266.08 C 563.94 269.76 571.26 272.41 578.12 275.98 C 582.65 278.59 588.12 277.94 593.03 277.01 C 619.97 271.00 646.65 263.80 673.53 257.61 C 677.07 260.94 679.19 265.42 681.52 269.61 C 685.11 276.46 689.01 283.14 692.57 290.01 C 683.15 293.41 673.65 296.63 664.33 300.30 C 660.80 301.76 656.96 302.60 653.80 304.82 C 650.64 307.31 647.95 310.44 646.12 314.03 C 640.31 325.27 634.63 336.58 628.42 347.60 C 626.44 350.68 627.31 354.90 624.61 357.57 C 620.34 361.79 617.13 368.09 610.82 369.41 C 608.09 369.67 607.94 372.90 606.93 374.88 C 601.47 378.50 595.77 381.75 590.32 385.37 C 587.55 387.25 584.35 388.54 580.99 388.74 C 572.65 389.20 564.42 387.29 556.09 387.34 C 550.65 387.47 545.42 385.83 540.09 385.06 C 539.17 384.11 538.08 383.80 536.83 384.13 C 535.63 383.82 534.45 383.51 533.26 383.22 C 532.70 383.45 531.57 383.90 531.01 384.12 L 530.16 384.00 C 529.60 384.24 528.47 384.72 527.91 384.96 C 523.98 385.98 520.12 387.20 516.23 388.30 C 515.64 388.48 514.46 388.84 513.87 389.02 C 512.30 389.39 510.72 389.76 509.16 390.14 C 508.60 390.39 507.47 390.88 506.90 391.13 C 501.34 391.79 495.71 392.04 490.20 393.09 C 488.85 392.76 487.78 393.15 486.99 394.26 L 486.16 394.14 C 484.83 393.77 483.76 394.14 482.97 395.27 L 482.18 395.14 C 480.86 394.75 479.80 395.13 479.02 396.28 C 471.98 396.52 465.02 397.52 458.18 399.16 C 456.87 398.74 455.78 399.06 454.91 400.12 C 454.48 400.14 453.62 400.20 453.19 400.23 C 452.61 400.43 451.44 400.83 450.85 401.02 C 449.95 401.32 449.05 401.63 448.16 401.94 C 447.61 402.22 446.52 402.79 445.98 403.07 C 440.25 405.09 435.25 409.03 429.09 409.78 C 425.44 410.25 421.87 412.50 418.16 411.32 C 413.84 410.03 409.47 408.89 405.05 408.03 C 404.49 407.79 403.36 407.31 402.79 407.07 C 397.80 405.08 393.51 401.76 389.95 397.78 C 386.25 393.36 381.26 390.01 378.37 384.96 C 382.42 383.68 386.12 381.53 390.05 379.94 C 392.02 379.07 394.32 378.27 395.20 376.09 C 397.05 372.39 399.17 368.80 400.70 364.96 C 401.38 358.51 396.42 351.99 399.74 345.72 C 403.21 338.38 405.36 330.54 408.17 322.95 C 408.97 320.72 408.71 318.30 409.14 316.01 C 411.74 313.47 415.48 311.84 415.91 307.73 C 411.50 307.44 407.08 306.65 403.01 304.91 C 401.22 303.76 400.31 301.67 398.60 300.43 C 394.66 297.90 390.00 296.60 386.29 293.72 C 385.39 291.90 385.04 289.85 384.87 287.86 C 384.96 284.98 386.71 281.87 384.74 279.27 C 380.13 271.84 376.99 263.66 373.48 255.69 C 371.68 251.47 369.63 247.35 368.22 242.98 C 367.04 238.87 364.22 235.57 361.97 232.03 C 357.97 233.28 354.01 234.66 350.04 236.03 C 347.97 232.49 345.41 229.30 343.02 225.99 C 339.74 220.91 337.32 215.33 335.11 209.72 C 334.57 209.58 333.50 209.29 332.97 209.14 L 333.16 208.02 Z" style="fill: rgb(255, 0, 0);"></path>
    <path id="path1" fill="#505389" opacity="1.00" d=" M 466.30 2.70 C 479.99 2.36 493.62 1.00 507.30 0.35 C 504.80 4.75 500.83 8.25 499.07 13.05 C 497.56 17.77 495.99 22.48 494.20 27.11 C 492.99 30.90 490.85 34.86 491.94 38.92 C 496.08 41.81 501.03 43.17 505.55 45.34 C 511.62 48.26 517.97 50.70 523.64 54.37 C 525.92 55.70 526.06 58.60 526.93 60.83 C 530.54 61.55 534.11 62.45 537.62 63.55 C 535.73 70.25 533.79 76.95 532.05 83.70 C 541.50 87.10 550.83 90.84 560.25 94.34 C 557.72 99.32 554.38 103.82 551.49 108.57 C 540.82 125.23 530.44 142.07 519.59 158.60 C 512.26 170.72 505.97 183.45 498.22 195.32 C 495.64 193.67 492.74 192.68 489.81 191.91 C 487.81 197.06 487.18 202.61 485.34 207.82 C 482.18 207.35 479.04 206.67 475.84 206.50 C 473.70 207.84 472.63 210.27 471.31 212.33 C 467.07 219.86 461.87 226.80 456.76 233.74 C 452.53 237.77 450.42 243.30 448.27 248.59 C 439.02 244.05 429.36 240.43 420.15 235.82 C 403.09 227.62 385.60 220.30 368.64 211.88 C 367.38 204.52 366.16 197.13 364.29 189.90 C 357.36 188.78 350.66 186.60 343.81 185.09 C 341.14 184.29 337.99 184.15 335.94 182.02 C 331.53 177.76 327.01 173.56 322.14 169.82 C 316.13 165.83 310.16 161.76 304.08 157.88 C 316.61 142.51 329.49 127.42 342.09 112.10 C 345.88 108.18 350.95 105.85 355.15 102.41 C 365.79 111.13 376.77 119.44 387.39 128.18 C 388.98 127.56 390.57 126.92 392.12 126.19 C 410.23 116.99 428.39 107.88 446.52 98.72 C 451.71 96.17 457.42 94.98 462.88 93.17 C 462.01 73.76 460.65 54.39 459.40 35.01 C 459.55 28.62 463.85 23.35 467.42 18.39 C 466.31 13.23 466.41 7.94 466.30 2.70 Z" style="fill: rgb(255, 0, 0);"></path>
    <path id="path2" fill="#00ff00" opacity="1.00" d=" M 507.56 0.00 L 571.96 0.00 C 573.72 1.40 575.42 3.20 577.88 3.07 C 581.03 3.48 584.20 3.65 587.38 3.82 C 587.74 3.86 588.45 3.94 588.81 3.98 C 591.97 4.44 595.15 4.67 598.35 4.79 C 598.95 4.86 600.14 4.99 600.74 5.05 C 603.61 5.45 606.49 5.65 609.39 5.78 C 609.99 5.85 611.19 5.98 611.79 6.04 C 614.64 6.44 617.51 6.64 620.39 6.76 C 621.47 6.89 622.57 7.00 623.68 7.10 C 626.54 7.49 629.41 7.70 632.30 7.84 C 632.90 7.90 634.10 8.02 634.70 8.08 C 637.53 8.47 640.37 8.69 643.23 8.81 C 643.86 8.87 645.11 9.00 645.74 9.07 C 647.29 9.26 648.82 9.49 650.38 9.71 C 650.08 10.43 649.47 11.85 649.16 12.56 L 648.49 13.84 C 648.43 13.95 648.31 14.18 648.24 14.30 L 647.77 15.17 C 647.66 15.36 647.45 15.75 647.35 15.95 L 646.83 16.95 C 646.68 17.27 646.37 17.90 646.22 18.21 L 645.78 19.07 C 645.71 19.20 645.58 19.47 645.51 19.60 C 642.15 26.73 638.50 33.71 635.11 40.82 C 632.39 45.81 629.73 50.84 627.68 56.14 L 627.49 56.54 C 627.42 56.69 627.28 56.99 627.21 57.14 L 626.84 57.91 C 626.77 58.06 626.63 58.37 626.55 58.52 C 625.37 61.43 623.72 64.10 622.01 66.71 C 620.73 67.14 620.07 68.03 620.04 69.39 C 617.63 72.78 615.23 76.17 613.00 79.68 C 611.73 80.14 611.09 81.03 611.08 82.38 C 610.72 82.88 610.00 83.88 609.63 84.38 C 609.58 84.46 609.47 84.61 609.42 84.68 C 606.48 88.92 603.58 93.18 600.63 97.40 C 600.58 97.47 600.47 97.62 600.42 97.69 C 597.83 101.49 595.18 105.25 592.64 109.08 C 597.58 112.81 602.58 116.46 607.69 119.95 C 608.10 121.23 608.99 121.89 610.35 121.93 C 612.34 123.44 614.30 125.00 616.46 126.28 C 616.50 126.31 616.59 126.35 616.64 126.37 C 619.74 124.21 622.25 121.35 625.01 118.80 C 627.12 119.97 629.22 121.16 631.34 122.32 C 631.43 122.36 631.60 122.45 631.69 122.49 C 632.21 122.73 633.25 123.21 633.78 123.45 C 635.01 126.67 634.55 130.17 634.49 133.54 C 629.16 137.70 627.38 144.42 624.03 150.00 C 621.01 155.10 618.91 160.70 615.67 165.68 C 613.99 167.20 613.81 169.62 612.69 171.49 C 608.95 178.14 604.73 184.55 601.50 191.49 C 595.79 203.43 590.54 215.60 584.35 227.31 C 577.43 240.36 570.48 253.41 563.22 266.28 C 562.21 269.44 559.00 267.02 557.15 266.08 C 556.01 265.38 554.91 264.63 553.74 264.02 C 553.19 263.75 552.10 263.22 551.55 262.95 C 553.85 258.48 555.10 253.59 556.16 248.71 C 549.29 248.54 542.42 248.74 535.55 248.52 C 536.79 243.29 537.26 237.37 541.74 233.71 C 541.36 233.22 540.61 232.24 540.24 231.75 C 543.46 229.25 546.70 226.80 549.94 224.32 C 546.56 220.32 541.35 218.89 537.43 215.57 C 532.14 211.64 526.87 207.66 521.44 203.91 C 520.36 204.81 519.31 205.78 518.11 206.51 C 511.41 202.92 504.91 198.94 498.22 195.32 C 505.97 183.45 512.26 170.72 519.59 158.60 C 530.44 142.07 540.82 125.23 551.49 108.57 C 554.38 103.82 557.72 99.32 560.25 94.34 C 550.83 90.84 541.50 87.10 532.05 83.70 C 533.79 76.95 535.73 70.25 537.62 63.55 C 534.11 62.45 530.54 61.55 526.93 60.83 C 526.06 58.60 525.92 55.70 523.64 54.37 C 517.97 50.70 511.62 48.26 505.55 45.34 C 501.03 43.17 496.08 41.81 491.94 38.92 C 490.85 34.86 492.99 30.90 494.20 27.11 C 495.99 22.48 497.56 17.77 499.07 13.05 C 500.83 8.25 504.80 4.75 507.30 0.35 L 507.56 0.00 Z" style="fill: rgb(255, 153, 102);"></path>
    <path fill="#00ff00" opacity="1.00" d=" M 533.15 256.01 C 533.70 254.73 534.99 255.96 535.80 256.18 C 540.58 258.72 545.53 260.91 550.61 262.80 C 549.85 263.48 549.08 264.14 548.33 264.83 C 538.83 268.60 529.50 272.84 520.28 277.23 C 519.08 274.35 515.80 271.41 517.28 268.14 C 519.49 266.62 522.16 265.99 524.64 265.05 C 524.53 264.55 524.32 263.54 524.21 263.04 C 527.54 261.18 531.18 259.46 533.15 256.01 Z"></path>
    <path id="path3" fill="#d47fd4" opacity="1.00" d=" M 332.97 209.14 C 333.50 209.29 334.57 209.58 335.11 209.72 C 337.32 215.33 339.74 220.91 343.02 225.99 C 345.41 229.30 347.97 232.49 350.04 236.03 C 354.01 234.66 357.97 233.28 361.97 232.03 C 364.22 235.57 367.04 238.87 368.22 242.98 C 369.63 247.35 371.68 251.47 373.48 255.69 C 376.99 263.66 380.13 271.84 384.74 279.27 C 386.71 281.87 384.96 284.98 384.87 287.86 C 385.04 289.85 385.39 291.90 386.29 293.72 C 390.00 296.60 394.66 297.90 398.60 300.43 C 400.31 301.67 401.22 303.76 403.01 304.91 C 407.08 306.65 411.50 307.44 415.91 307.73 C 415.48 311.84 411.74 313.47 409.14 316.01 C 408.71 318.30 408.97 320.72 408.17 322.95 C 405.36 330.54 403.21 338.38 399.74 345.72 C 396.42 351.99 401.38 358.51 400.70 364.96 C 399.17 368.80 397.05 372.39 395.20 376.09 C 394.32 378.27 392.02 379.07 390.05 379.94 C 386.12 381.53 382.42 383.68 378.37 384.96 C 381.26 390.01 386.25 393.36 389.95 397.78 C 386.86 394.90 384.24 391.46 380.50 389.37 C 378.25 387.95 377.89 384.70 375.13 383.94 C 374.74 383.55 373.96 382.75 373.57 382.35 C 366.94 381.69 360.40 383.12 353.84 383.83 C 338.31 385.72 322.53 386.81 307.57 391.73 C 302.16 393.34 296.73 395.03 291.10 395.63 C 287.85 396.10 284.50 396.23 281.44 397.55 C 280.90 397.82 279.80 398.34 279.25 398.60 C 277.14 401.94 273.96 404.45 272.03 407.90 C 269.39 410.69 266.02 412.64 263.45 415.51 C 259.51 419.32 255.12 423.16 249.78 424.77 C 243.33 424.78 236.84 424.65 230.41 425.40 C 229.58 426.28 228.73 427.15 227.87 428.00 C 225.05 429.03 224.37 432.30 222.76 434.52 C 218.64 442.75 212.34 449.70 205.85 456.15 C 202.01 457.56 198.23 459.10 194.44 460.63 C 191.68 461.84 188.88 462.95 185.97 463.70 C 185.55 464.45 185.15 465.21 184.77 465.99 C 189.92 468.96 195.75 470.52 200.86 473.57 C 201.35 473.50 202.32 473.34 202.81 473.27 C 201.37 474.65 199.98 476.07 198.69 477.60 C 197.02 480.11 194.81 482.18 192.75 484.36 C 191.93 485.48 191.18 486.66 190.47 487.86 C 188.50 486.75 186.51 485.69 184.51 484.62 C 182.18 483.52 179.87 482.38 177.55 481.26 C 177.38 479.42 178.29 476.77 175.77 476.30 C 170.99 474.33 167.11 470.93 163.09 467.80 C 162.33 466.82 161.63 465.80 161.03 464.73 C 159.67 462.67 158.34 460.58 157.28 458.35 C 156.93 457.96 156.21 457.18 155.85 456.80 C 155.53 455.96 155.20 455.13 154.87 454.31 C 153.42 454.36 151.98 454.42 150.54 454.49 C 149.67 450.95 148.76 447.41 147.75 443.90 C 158.51 439.71 169.52 436.15 180.76 433.48 C 181.94 432.13 183.04 430.71 184.04 429.23 C 187.87 425.28 190.97 420.71 194.54 416.54 C 198.12 413.44 202.04 410.73 205.94 408.04 C 205.58 406.55 204.67 405.47 203.20 405.00 C 201.33 403.17 199.41 401.40 197.28 399.89 C 195.03 398.15 192.72 396.49 190.31 394.99 C 188.05 393.12 185.65 391.42 183.18 389.86 C 184.63 388.42 186.10 386.98 187.57 385.56 C 187.62 385.12 187.70 384.24 187.75 383.80 C 186.68 383.11 185.60 382.45 184.52 381.81 C 182.20 380.37 179.86 378.98 177.34 377.92 C 178.79 376.94 180.09 375.77 181.11 374.35 C 181.63 374.66 182.16 374.98 182.68 375.30 C 184.29 376.33 185.87 377.42 187.44 378.50 C 188.11 378.61 189.43 378.83 190.09 378.93 C 191.66 377.38 193.23 375.82 194.80 374.27 C 197.31 375.70 199.88 377.01 202.46 378.32 C 203.42 378.77 204.38 379.22 205.34 379.68 C 206.79 380.44 208.25 381.20 209.70 381.99 C 211.10 382.91 212.43 384.08 214.06 384.57 C 218.10 384.96 222.03 383.61 226.04 383.43 C 225.09 381.14 224.12 378.85 223.28 376.52 C 222.62 375.18 221.96 373.83 221.32 372.48 C 220.11 370.07 218.91 367.66 217.66 365.27 C 218.57 364.02 219.48 362.77 220.43 361.56 C 220.96 360.19 221.62 358.85 221.70 357.37 C 217.06 354.55 211.88 352.77 206.87 350.73 C 207.32 350.70 208.22 350.63 208.67 350.59 C 208.74 349.37 208.81 348.14 208.88 346.92 C 208.17 347.04 206.76 347.28 206.05 347.39 C 200.42 351.27 195.76 356.33 190.79 360.98 C 189.61 361.73 188.46 362.54 187.46 363.52 C 183.25 367.74 178.18 370.95 173.79 374.96 C 170.91 377.16 167.81 379.06 164.74 380.99 C 162.32 382.24 159.92 383.51 157.49 384.74 C 155.86 385.81 154.20 386.82 152.52 387.80 C 143.67 391.83 134.24 394.24 124.99 397.11 C 121.49 398.02 117.72 397.81 114.45 399.54 C 112.78 401.35 110.70 402.69 108.51 403.82 C 106.22 405.30 103.82 406.62 101.32 407.72 C 100.95 408.02 100.23 408.61 99.86 408.91 C 98.61 409.51 97.57 410.41 96.92 411.65 C 91.10 419.26 85.67 427.17 79.53 434.51 C 79.36 435.47 79.19 436.44 79.03 437.41 C 80.66 437.81 82.28 438.24 83.91 438.66 C 82.87 443.12 80.42 447.02 77.56 450.52 C 77.48 450.97 77.32 451.88 77.24 452.33 C 82.10 453.98 86.91 455.80 91.77 457.45 C 89.35 461.81 89.01 467.75 84.17 470.33 C 79.17 474.76 73.96 478.96 69.17 483.62 C 70.23 489.48 73.49 494.63 75.58 500.15 C 72.78 503.73 69.69 507.08 66.94 510.70 C 61.54 517.33 56.21 524.00 50.94 530.72 C 47.99 534.25 45.29 538.01 41.90 541.15 C 37.55 541.33 33.19 541.33 28.90 542.11 C 27.57 542.52 26.33 541.64 25.25 541.02 C 20.40 536.82 16.30 531.81 11.46 527.60 C 8.64 525.43 6.05 523.00 3.27 520.78 C 7.47 519.92 10.96 517.29 14.92 515.82 C 19.94 513.94 24.45 510.95 29.53 509.25 C 32.64 507.06 35.90 505.09 39.01 502.92 C 40.39 502.16 40.58 500.50 41.10 499.18 C 42.84 493.59 45.20 488.22 46.93 482.64 C 41.91 481.64 36.94 480.38 32.01 479.05 C 24.33 476.40 17.29 472.25 9.76 469.24 C 6.54 467.97 3.62 465.47 0.00 465.60 L 0.00 465.21 C 1.15 464.60 2.32 464.02 3.48 463.46 C 10.52 456.01 18.35 449.29 24.93 441.43 C 31.05 446.65 38.06 450.65 44.51 455.43 C 45.06 455.54 46.14 455.78 46.69 455.89 C 46.58 451.99 47.11 447.92 45.53 444.24 C 45.04 443.89 44.06 443.19 43.57 442.85 C 44.55 441.04 45.51 439.21 46.51 437.42 C 46.53 436.47 46.55 435.52 46.57 434.58 C 44.72 432.86 43.31 430.76 42.19 428.51 C 40.75 426.24 39.43 423.89 38.23 421.49 C 36.90 419.42 35.65 417.31 34.40 415.20 C 34.89 410.60 35.88 406.03 35.65 401.38 C 35.21 401.02 34.32 400.29 33.87 399.92 C 33.37 398.77 32.84 397.63 32.32 396.50 C 28.64 392.10 28.55 386.02 26.01 381.05 C 24.64 379.27 22.83 377.93 21.07 376.59 C 23.99 376.21 26.90 375.72 29.84 375.52 C 29.76 374.95 29.61 373.82 29.53 373.25 C 28.73 372.63 27.92 372.02 27.12 371.42 C 33.94 371.85 40.84 370.95 47.60 372.29 C 51.42 372.77 55.34 372.82 59.15 372.17 C 64.49 371.05 69.97 371.75 75.37 371.49 C 79.15 368.68 83.48 366.78 87.42 364.24 C 88.00 364.03 89.16 363.62 89.73 363.41 C 94.00 359.38 96.56 353.98 100.41 349.59 C 101.33 347.46 102.17 345.30 102.70 343.05 C 105.22 332.62 107.88 322.23 110.39 311.81 C 110.95 309.22 112.06 306.81 113.27 304.48 C 113.53 303.98 114.05 302.98 114.31 302.48 C 114.57 301.99 115.11 301.00 115.37 300.50 C 115.81 299.45 116.25 298.39 116.69 297.34 C 123.16 300.35 129.95 302.58 136.56 305.25 C 144.00 308.16 151.54 310.85 158.89 314.03 C 160.42 315.08 162.06 314.02 163.53 313.44 C 165.33 312.03 167.21 310.75 169.08 309.44 C 167.73 305.30 163.53 303.14 161.02 299.78 C 156.96 294.08 151.44 289.56 146.46 284.68 C 147.89 272.34 150.05 260.10 151.72 247.80 C 153.58 246.51 155.47 245.25 157.49 244.21 C 158.57 243.55 159.65 242.89 160.73 242.24 C 160.92 239.76 161.19 237.29 161.51 234.82 C 171.70 234.64 181.90 234.70 192.09 234.43 C 199.48 233.50 206.94 233.84 214.37 233.54 C 215.93 238.13 217.58 242.70 218.71 247.42 C 226.60 271.53 233.66 295.90 241.55 320.01 C 243.92 319.18 246.29 318.32 248.65 317.44 C 251.80 314.28 254.86 311.02 258.17 308.02 C 259.56 307.07 260.94 306.10 262.32 305.13 C 264.80 303.30 266.99 301.13 269.21 299.01 C 274.23 295.77 277.53 290.28 283.37 288.16 C 286.51 286.30 287.77 282.70 290.07 280.04 C 295.13 273.87 299.99 267.51 305.37 261.61 C 307.81 255.95 309.53 250.00 312.24 244.45 C 313.37 241.36 314.81 238.41 316.27 235.47 C 317.72 231.12 320.20 227.22 321.81 222.93 C 323.93 217.68 327.05 212.11 332.78 210.24 C 332.83 209.96 332.92 209.42 332.97 209.14 Z" style="fill: rgb(255, 0, 0);"></path>
    <path id="path4" fill="#af640d" opacity="1.00" d=" M 744.73 82.68 C 747.94 78.96 751.21 75.29 754.61 71.73 C 776.81 97.68 800.41 122.38 823.24 147.77 C 872.87 201.89 922.15 256.33 971.72 310.50 C 986.95 308.03 1002.26 306.01 1017.51 303.68 C 1018.93 308.66 1020.01 313.73 1021.26 318.75 C 1021.43 319.35 1021.76 320.53 1021.93 321.13 C 1022.64 324.67 1023.50 328.19 1024.34 331.71 C 1029.22 333.49 1033.80 336.43 1038.96 337.25 C 1074.53 334.60 1110.11 331.80 1145.69 329.14 C 1144.24 335.06 1142.57 340.96 1141.76 347.02 C 1141.24 350.80 1142.16 354.81 1140.69 358.44 C 1136.43 369.40 1132.21 380.37 1128.06 391.36 C 1118.34 390.07 1108.63 388.81 1098.92 387.48 C 1093.79 386.78 1089.51 382.35 1084.12 383.51 C 1073.18 384.77 1062.25 386.03 1051.31 387.24 C 1050.43 392.22 1049.60 397.21 1048.69 402.19 C 1043.09 402.33 1037.50 402.19 1031.90 402.24 C 1028.73 402.09 1026.04 403.98 1023.30 405.27 C 1017.60 408.31 1011.23 409.66 1005.12 411.58 C 1003.15 406.14 1002.03 400.11 998.22 395.59 C 984.57 392.24 970.36 390.87 957.20 385.67 C 955.49 379.13 955.08 372.29 953.99 365.62 C 942.34 365.75 930.72 366.69 919.07 366.84 C 901.06 367.75 883.01 367.71 865.02 368.74 C 848.05 370.87 831.11 373.28 814.14 375.34 C 803.33 375.83 792.56 376.82 781.86 378.39 C 772.46 379.25 764.00 383.96 756.30 389.11 C 749.57 392.71 742.27 395.09 735.13 397.71 C 729.01 400.15 722.34 399.00 715.95 399.26 C 707.14 399.57 698.34 398.33 689.82 396.17 C 683.75 394.40 677.78 392.21 671.50 391.26 C 666.31 389.98 660.53 390.14 656.02 386.91 C 652.93 384.91 649.22 384.36 645.89 382.91 C 642.22 381.49 639.66 378.16 635.90 376.93 C 631.57 375.45 627.44 373.35 622.96 372.37 C 617.47 371.96 612.36 374.60 606.93 374.88 C 607.94 372.90 608.09 369.67 610.82 369.41 C 617.13 368.09 620.34 361.79 624.61 357.57 C 627.31 354.90 626.44 350.68 628.42 347.60 C 634.63 336.58 640.31 325.27 646.12 314.03 C 647.95 310.44 650.64 307.31 653.80 304.82 C 656.96 302.60 660.80 301.76 664.33 300.30 C 673.65 296.63 683.15 293.41 692.57 290.01 C 689.01 283.14 685.11 276.46 681.52 269.61 C 679.19 265.42 677.07 260.94 673.53 257.61 C 646.65 263.80 619.97 271.00 593.03 277.01 C 588.12 277.94 582.65 278.59 578.12 275.98 C 571.26 272.41 563.94 269.76 557.15 266.08 C 559.00 267.02 562.21 269.44 563.22 266.28 C 570.48 253.41 577.43 240.36 584.35 227.31 C 590.66 216.11 595.75 204.26 601.83 192.93 C 606.32 183.78 611.57 175.01 615.67 165.68 C 618.91 160.70 621.01 155.10 624.03 150.00 C 627.38 144.42 629.16 137.70 634.49 133.54 C 634.55 130.17 635.01 126.67 633.78 123.45 C 633.98 122.96 634.40 121.98 634.60 121.49 C 639.46 117.54 645.38 115.13 650.34 111.30 C 657.61 105.67 664.90 100.07 672.19 94.47 C 677.74 98.75 682.11 105.11 689.18 106.95 C 694.38 108.60 699.54 110.37 704.73 112.07 C 714.50 105.06 724.22 97.98 734.02 91.01 C 737.67 88.35 741.78 86.19 744.73 82.68 Z" style="fill: rgb(255, 0, 0);"></path>
    <path id="path5" fill="#c3164d" opacity="1.00" d=" M 489.81 191.91 C 492.74 192.68 495.64 193.67 498.22 195.32 C 504.91 198.94 511.41 202.92 518.11 206.51 C 519.31 205.78 520.36 204.81 521.44 203.91 C 526.87 207.66 532.14 211.64 537.43 215.57 C 541.35 218.89 546.56 220.32 549.94 224.32 C 546.70 226.80 543.46 229.25 540.24 231.75 C 540.61 232.24 541.36 233.22 541.74 233.71 C 537.26 237.37 536.79 243.29 535.55 248.52 C 542.42 248.74 549.29 248.54 556.16 248.71 C 555.10 253.59 553.85 258.48 551.55 262.95 C 552.10 263.22 553.19 263.75 553.74 264.02 C 553.34 263.97 552.54 263.88 552.13 263.84 C 550.85 264.14 549.59 264.48 548.33 264.83 C 549.08 264.14 549.85 263.48 550.61 262.80 C 545.53 260.91 540.58 258.72 535.80 256.18 C 534.99 255.96 533.70 254.73 533.15 256.01 C 531.18 259.46 527.54 261.18 524.21 263.04 C 524.32 263.54 524.53 264.55 524.64 265.05 C 522.16 265.99 519.49 266.62 517.28 268.14 C 515.80 271.41 519.08 274.35 520.28 277.23 C 514.25 280.81 508.51 284.86 502.72 288.82 C 501.81 288.52 500.91 288.23 500.01 287.94 C 494.24 291.82 488.66 296.13 482.24 298.91 C 482.65 294.14 483.71 289.47 484.42 284.75 C 483.57 283.69 482.73 282.62 481.91 281.56 C 480.68 281.65 479.46 281.74 478.24 281.84 C 476.74 280.42 475.24 279.00 473.74 277.59 C 473.34 277.63 472.53 277.72 472.13 277.76 C 469.71 276.20 467.34 274.45 464.56 273.62 C 460.92 272.90 457.01 274.07 453.53 272.50 C 450.56 271.33 447.67 269.99 444.71 268.81 C 446.45 264.78 448.97 261.15 452.08 258.06 C 453.95 256.34 454.49 253.83 455.05 251.46 C 452.77 250.54 450.50 249.60 448.27 248.59 C 450.42 243.30 452.53 237.77 456.76 233.74 C 461.87 226.80 467.07 219.86 471.31 212.33 C 472.63 210.27 473.70 207.84 475.84 206.50 C 479.04 206.67 482.18 207.35 485.34 207.82 C 487.18 202.61 487.81 197.06 489.81 191.91 Z" style="fill: rgb(0, 255, 0);"></path>
    <text x="850" y="250" font-size="18px" fill="#000000">منطقه یک </text>
    <text id="region1" x="850" y="280" font-size="18px" fill="#000000">(248)</text>
    <text x="550" y="340" font-size="18px" fill="#000000">منطقه دو </text>
    <text id="region2" x="550" y="370" font-size="18px" fill="#000000">(275)</text>
    <text x="380" y="300" font-size="18px" fill="#000000">منطقه سه </text>
    <text id="region3" x="380" y="330" font-size="18px" fill="#000000">(289)</text>
    <text x="500" y="150" font-size="18px" fill="#000000">منطقه چهار </text>
    <text id="region4" x="500" y="180" font-size="18px" fill="#000000">(229)</text>
    <text x="620" y="60" font-size="18px" fill="#000000">منطقه پنج </text>
    <text id="region5" x="620" y="90" font-size="18px" fill="#000000">(216)</text>
    <text x="540" y="240" font-size="18px" fill="#000000">بافت تاریخی </text>
    <text id="region6" x="540" y="260" font-size="18px" fill="#000000">(22)</text>
</g>
</svg>
`;
        return (
            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            //  menu={!checkLogin}
                            menu={typeExport._NameApp != "MahalemaArak"}
                            // menu
                            back={typeExport._NameApp != "MahalemaArak"}
                            //  exit={checkLogin && !type}
                            //  exit={checkLogin && !type}
                            exit={typeExport._NameApp == "MahalemaArak"}
                            funcExit={checkLogin ? () => {

                                HMAlert(
                                    i18n.t('constant.message'),
                                    "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                                    [
                                        // {text: 'Ask me later', onPress: () => {}},
                                        {
                                            text: i18n.t('constant.No'), onPress: () => {
                                            }, style: 'cancel'
                                        },
                                        {
                                            text: i18n.t('constant.Yes'), onPress: () => {
                                                AsyngStorageClass.removeToken(typeExport._Shahrdar);
                                                NavigationService.resetTo('LoginStackScreen');

                                            }
                                        },
                                    ],
                                    {cancelable: true}
                                )


                                // Tools.remove()
                                // NavigationService.resetTo("SplashScreen")
                            } : null}
                            props={this.props} statusBarTransparent
                            //  text={i18n.t('Apply.title')}
                            // text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? this.props.DataSplashScreen.user.name + " " + this.props.DataSplashScreen.user.family : null}
                            text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? i18n.t('appName') : null}
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}
                            // funcExit={checkLogin ? () => {
                            //
                            //     HMAlert(
                            //         i18n.t('constant.message'),
                            //         "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                            //         [
                            //             // {text: 'Ask me later', onPress: () => {}},
                            //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            //             {
                            //                 text: i18n.t('constant.ok'), onPress: () => {
                            //                     AsyngStorageClass.removeToken(typeExport._Shahrdar);
                            //                 }
                            //             },
                            //         ],
                            //         {cancelable: true}
                            //     )
                            //
                            //
                            //     // Tools.remove()
                            //     // NavigationService.resetTo("SplashScreen")
                            // } : null}
                            styleText={[!checkLogin ? {} : {marginStart: moderateScale(48)}]}
                            ViewCenter={
                                (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") && OrganCity && (item?.typepm == "mahale" ? true : !(item?.type == 7)) ?
                                    () => {
                                        return <View style={{flexDirection: "row"}}>

                                            <HMTextView
                                                numberOfLines={1}
                                                text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? i18n.t('appName') : null}
                                                type="bold"
                                                style={{
                                                    alignSelf: "center",
                                                    color: Colors.light,
                                                    fontSize: moderateScale(16),
                                                }}
                                            />

                                            <HMTextView
                                                numberOfLines={1}
                                                text={OrganCity ? ` (${OrganCity.name}) ` : ""}
                                                type="bold"
                                                style={{
                                                    alignSelf: "center",
                                                    color: Colors.light,
                                                    fontSize: moderateScale(16),
                                                    marginHorizontal: moderateScale(8)
                                                }}
                                            />

                                            <HMIcon
                                                type={"AntDesign"}
                                                // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                name={"sync"}
                                                //resizeMode="stretch"
                                                style={[{fontSize: moderateScale(24)}, {
                                                    color: Colors.white
                                                }]}
                                                onPress={() => {
                                                    NavigationService.navigateParams("ListCityScreen", {type: "orgs"})
                                                }}
                                            />
                                        </View>
                                    }
                                    :
                                    null
                            }
                        />

                        {
                            (!this.props.DataSplashScreen.NoInternetDialogShahrdar) && (!this.props.DataSplashScreen.isLoadingShahrdar) ?
                                null
                                :
                                <View
                                    style={{
                                        width: "100%",
                                        //  flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: this.props.DataSplashScreen.NoInternetDialogShahrdar ? Colors.red : Colors.white,
                                        alignSelf: 'center',
                                        padding: moderateScale(6)
                                    }}
                                >
                                    {this.props.DataSplashScreen.NoInternetDialogShahrdar ?
                                        <View
                                            style={{
                                                width: "100%",
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={"bold"}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: "center",
                                                        color: Colors.white,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={"خطایی رخ داده مجددا تلاش نمایید"}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.getDataServerSplash()

                                                }}
                                                style={{
                                                    // flex: .33,
                                                    // width: '92%',
                                                    // height: moderateScale(28),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.yellow,
                                                    borderRadius: moderateScale(6),
                                                    marginHorizontal: moderateScale(2),
                                                    paddingHorizontal: moderateScale(4),
                                                    paddingVertical: moderateScale(2),


                                                }}>

                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    text={i18n.t('constant.Update')}
                                                    //  text={"ثبت و بستن تیکت"}
                                                    type={"bold"}
                                                    style={{
                                                        fontSize: moderateScale(10),
                                                        marginVertical: moderateScale(2),
                                                        //     marginHorizontal: moderateScale(4),
                                                        color: Colors.white
                                                    }}/>
                                            </TouchableOpacity>

                                        </View>
                                        :

                                        <View
                                            style={{
                                                width: "100%",
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={"bold"}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={i18n.t('constant.Update')}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <ActivityIndicator color={Colors.colorPrimary} size={"small"}/>

                                        </View>
                                    }
                                </View>


                        }
                        {/*       <View style={{width: "100%", height: moderateScale(200)}}>
                            <HMSvgXml xml={xml} width="100%" height="100"/>
                        </View>*/}
                        <View style={{flex: 1, alignItems: 'center'}}>

                            {
                                this.props.results == null && this.props.isLoading && request_server ?
                                    <HMLoading/>

                                    :
                                    <ScrollView
                                        style={{
                                            //   backgroundColor:"#dd2dee"
                                        }}>
                                        <View
                                            style={{
                                                //position:'absolute',
                                                flexDirection: "row",
                                                flexWrap: 'wrap',
                                                flex: 1,

                                                flexGrow: 1,
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginTop: moderateScale(12)
                                                //  backgroundColor: _main ? "#eee" : Colors.transparent,
                                                //  backgroundColor: "#876a79",
                                            }}>


                                            {
                                                dataList && dataList.length > 0 ?
                                                    dataList.map((item, key) => {
                                                        //  (this.state.data).find((obj) => obj.locale == i18n.locale).list.map((item, key) => {
                                                        return (
                                                            //type=0 => پیوند ,type=1 => اخبار ,type=2 => صفحه ,type=3 => منو ,type=4 => اسلایدر ,type=5 => 137 یار ,type=6 => نقشه ,,type=7 => بازرسی ,,type=8 =>  ارامستان ,
                                                            <TouchableOpacity
                                                                key={key + "iii"}
                                                                onPress={() => {

                                                                    if (checkLogin && (item?.typepm == "mahale" ? true : !(item?.type == 7))) {

                                                                        if (type === "report") {

                                                                            switch (item.type) {

                                                                                case 1:
                                                                                    NavigationService.navigateParams("ListReport15RequestScreen", {
                                                                                        data: item, Extras: item
                                                                                    })
                                                                                    break;

                                                                                case 2:
                                                                                    NavigationService.navigateParams("ListReportStatusRequestScreen", {
                                                                                        data: item,
                                                                                        Extras: item,
                                                                                        type: "report"
                                                                                    })
                                                                                    break;

                                                                                case 3:
                                                                                    NavigationService.navigateParams("ListReport15RequestScreen", {
                                                                                        data: item, Extras: item
                                                                                    })
                                                                                    break;

                                                                                case 4:
                                                                                    NavigationService.navigateParams("ListReportStatusRequestScreen", {
                                                                                        data: item,
                                                                                        Extras: item,
                                                                                        type: "report"
                                                                                    })
                                                                                    break;

                                                                                case 5:
                                                                                    NavigationService.navigateParams("ListReportArrearsScreen", {
                                                                                        data: item,
                                                                                        Extras: item,
                                                                                        type: "report"
                                                                                    })
                                                                                    break;


                                                                                case "m_1":
                                                                                    if (this.props.DataSplashScreen.tokenMahaleh) {
                                                                                        NavigationService.navigateParams("ListOperatorApplyScreen", {
                                                                                            item: item,
                                                                                            data: item,
                                                                                            Extras: item,
                                                                                            itemOriginal: item,
                                                                                            type: "requestMahalehMa"
                                                                                        })
                                                                                    }
                                                                                    else {
                                                                                        AsyngStorageClass.removeToken();
                                                                                    }

                                                                                    break;

                                                                                case "m_2":
                                                                                    if (this.props.DataSplashScreen.tokenMahaleh) {
                                                                                        NavigationService.navigateParams("ListReportExitEnterMahalehMaScreen", {
                                                                                            data: item,
                                                                                            Extras: item,
                                                                                            type: "report"
                                                                                        })
                                                                                    }
                                                                                    else {
                                                                                        AsyngStorageClass.removeToken();
                                                                                    }
                                                                                    break;
                                                                                case "d_1":

                                                                                    //  NavigationService.navigateParams("ListReportCategoryScreen", {
                                                                                    //   NavigationService.navigateParams("ApplyScreen", {
                                                                                    //       // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                    //       data: item, item: item,
                                                                                    //   })

                                                                                    if (this.props.DataSplashScreen.tokenLaravel) {
                                                                                        NavigationService.navigateKeyDynamic("UnitsMyStateScreen", {
                                                                                            // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                            data: item,
                                                                                            item: item,
                                                                                            itemOriginal: item,
                                                                                            type: "requestMahalehMa"
                                                                                        })
                                                                                    }
                                                                                    else {
                                                                                        AsyngStorageClass.removeToken();
                                                                                    }
                                                                                    break;

                                                                                case "d_2":
                                                                                    if (this.props.DataSplashScreen.tokenLaravel) {
                                                                                        NavigationService.navigateKeyDynamic("EditPatternShowMyStateScreen", {
                                                                                            //  NavigationService.navigateKeyDynamic("DashboardMyStateScreen", {
                                                                                            // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                            data: item,
                                                                                            item: item,
                                                                                            itemOriginal: item,
                                                                                            type: "requestMahalehMa"
                                                                                        });
                                                                                    }
                                                                                    else {
                                                                                        AsyngStorageClass.removeToken();
                                                                                    }
                                                                                    break;


                                                                                default:
                                                                            }
                                                                        }
                                                                        else
                                                                            switch (item.type) {

                                                                                case 1:
                                                                                    // Toast.show({
                                                                                    //     text1: 'Hello',
                                                                                    //     text2: 'This is some something 👋'
                                                                                    // })

                                                                                    NavigationService.navigateParams("ListOperatorApplyScreen", {
                                                                                        //  NavigationService.navigateParams("ListUserChatScreen", {
                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item, item: item,
                                                                                    })
                                                                                    break;

                                                                                case 2:
                                                                                    NavigationService.navigateParams("ListOperatorApplyScreen", {

                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item, item: item,
                                                                                    })
                                                                                    break;
                                                                                case 3:
                                                                                    // NavigationService.navigateParams("SubmitRequestOperationScreen", {
                                                                                    //     // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                    //     data: item, item: item,
                                                                                    //     //position: {coords: {longitude: 46.574522, latitude: 39.454875}}
                                                                                    //   //  position: {coords: {longitude: 46.574522, latitude: 39.454875}}
                                                                                    // })

                                                                                    this.setState({isLoading: true,}, () => {
                                                                                        Tools.checkPermission(
                                                                                            "SubmitRequestScreen",
                                                                                            item,
                                                                                            null,
                                                                                            this.goScreen,
                                                                                            this.stateError
                                                                                        )
                                                                                    })
                                                                                    break;

                                                                                case 4:
                                                                                    NavigationService.navigateParams("ListMyApplyOperationScreen", {

                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item, item: item,
                                                                                    })
                                                                                    break;

                                                                                case 5:

                                                                                    NavigationService.navigateParams("GalleryServiceOperationScreen", {

                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item, item: item,
                                                                                    })
                                                                                    break;

                                                                                case 6:

                                                                                    //  NavigationService.navigateParams("ListReportCategoryScreen", {
                                                                                    //   NavigationService.navigateParams("ApplyScreen", {
                                                                                    //       // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                    //       data: item, item: item,
                                                                                    //   })
                                                                                    NavigationService.navigateKeyDynamic("ApplyScreen", {
                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: JSON.stringify(item),
                                                                                        item: JSON.stringify(item),
                                                                                        itemOriginal: item,
                                                                                        type: "report"
                                                                                    })
                                                                                    break;


                                                                                case 7:

                                                                                    //  NavigationService.navigateParams("ListReportCategoryScreen", {
                                                                                    //   NavigationService.navigateParams("ApplyScreen", {
                                                                                    //       // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                    //       data: item, item: item,
                                                                                    //   })
                                                                                    NavigationService.navigateKeyDynamic("ListOperatorApplyScreen", {
                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item,
                                                                                        item: item,
                                                                                        itemOriginal: item,
                                                                                        type: "requestMahalehMa"
                                                                                    })
                                                                                    break;

                                                                                case 9:
                                                                                    NavigationService.navigateParams("DashboardMyStateScreen", {
                                                                                        data: item,
                                                                                        Extras: item,
                                                                                        type: "report"
                                                                                    })
                                                                                    break;
                                                                                case 10:

                                                                                    NavigationService.navigateParams("GalleryServiceOperationScreen", {

                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item, item: item,
                                                                                    })
                                                                                    break;
                                                                                default:
                                                                            }
                                                                    }
                                                                    else {
                                                                        switch (item.typeClick) {

                                                                            case 1:
                                                                                // this.setState({isLoading: true,}, () => {
                                                                                //     Tools.checkPermission(
                                                                                //         "SubmitRequestScreen",
                                                                                //         item,
                                                                                //         null,
                                                                                //         this.goScreen,
                                                                                //         this.stateError
                                                                                //     )
                                                                                // })
                                                                                // NavigationService.navigateParams("SubmitRequestScreen", {
                                                                                //     item: this.props.route.params.item, data: item
                                                                                // })


                                                                                // container.setState({isLoading: false})

                                                                                NavigationService.navigateParams("SubmitRequestScreen", {
                                                                                    // position: JSON.stringify(Tools.cloneAsObject(position)),
                                                                                    //   position: JSON.stringify(position),
                                                                                    position: null,
                                                                                    typeComponent: (store.getState().reducerSplashGetAllData.TypeLogin == 2) ? "Operation" : null,
                                                                                    item: container.props.navigation && container.props.route && container.props.route.params ? container.props.route.params.item : JSON.stringify(item),
                                                                                    data: JSON.stringify(item),
                                                                                    type: "SubmitRequestScreen"
                                                                                });
                                                                                break;

                                                                            case 2:
                                                                                NavigationService.navigateParams("ListMyApplyScreen", {
                                                                                    item: this.props.route.params.item,
                                                                                    itemOriginal: this.props.route.params.itemOriginal,
                                                                                    data: JSON.stringify(item)
                                                                                })
                                                                                break;

                                                                            case 3:
                                                                                NavigationService.navigateParams("RegisterComplaintsScreen", {
                                                                                    item: this.props.route.params.item,
                                                                                    data: item
                                                                                })
                                                                                break;

                                                                            case 4:
                                                                                NavigationService.navigateParams("ListMyRegisterComplaintsScreen", {
                                                                                    item: this.props.route.params.item,
                                                                                    data: item
                                                                                })
                                                                                break;

                                                                            case 5:
                                                                                NavigationService.navigateParams("ApplyScreen2",
                                                                                    {
                                                                                        item: JSON.stringify(this.props.route.params.item),
                                                                                        data: JSON.stringify(item),
                                                                                        request_server: true,
                                                                                        list:
                                                                                            [
                                                                                                {
                                                                                                    name: 'درخواست ها و شکایات جدید',
                                                                                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                                                                    image: PathFile.image.Natije_Shekayat,
                                                                                                    typeClick: 1,
                                                                                                    type: 7
                                                                                                },
                                                                                                {
                                                                                                    name: 'در دست بررسی و اقدام',
                                                                                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                                                                    image: PathFile.image.Natije_Shekayat,
                                                                                                    typeClick: 2,
                                                                                                    type: 7
                                                                                                },

                                                                                            ]
                                                                                    })
                                                                                break;

                                                                            default:
                                                                        }
                                                                    }

                                                                }}
                                                                style={{
                                                                    // width: "100%",

                                                                    //  width: '100%',
                                                                    //  flex:1,
                                                                    height: this.state.itemWidth / 3 + moderateScale(10),
                                                                    marginHorizontal: moderateScale(4),
                                                                    marginBottom: moderateScale(4),
                                                                    borderRadius: moderateScale(6),
                                                                    //borderColor: '#d0d8df',
                                                                    borderColor: "#164A70",
                                                                    backgroundColor: Colors.white,
                                                                    borderWidth: moderateScale(1),
                                                                    //  marginVertical: moderateScale(2),
                                                                    // padding: moderateScale(6)
                                                                }}>
                                                                <View style={{
                                                                    flex: .8,
                                                                    width: this.state.itemWidth / 3 - moderateScale(10),
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}>

                                                                    <View
                                                                        style={{
                                                                            width: this.state.itemWidth / 7,
                                                                            height: this.state.itemWidth / 7,
                                                                        }}
                                                                    >
                                                                        {
                                                                            item.svg ?

                                                                                <HMIcon

                                                                                    //source={require('../../../../../assets/img/success.png')}
                                                                                    //source={PathFile.image.background}
                                                                                    //svg={PathFile.svg.add}
                                                                                    type={"svg"}
                                                                                    uri={item.svg}
                                                                                    height={this.state.itemWidth / 7}
                                                                                    width={this.state.itemWidth / 7}

                                                                                    name={"add-circle-sharp"} style={{
                                                                                    // fontSize: moderateScale(20),
                                                                                    // color: Colors.blue,
                                                                                    // marginHorizontal: moderateScale(4),
                                                                                    marginRight: moderateScale(4),
                                                                                    marginLeft: moderateScale(4),
                                                                                    //  marginTop: moderateScale(3)
                                                                                }}/>
                                                                                :
                                                                                (item.image_source ?

                                                                                        <HMImageView
                                                                                            // resizeMode={FastImage.resizeMode.contain}
                                                                                            resizeMode={"contain"}
                                                                                            _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}
                                                                                            //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                            // uriComplete={item.image}
                                                                                            source_image={item.image_source}
                                                                                            styleText={{marginTop: moderateScale(10)}}
                                                                                            borderRadius={4}/>
                                                                                        :
                                                                                        <HMImageView
                                                                                            // resizeMode={FastImage.resizeMode.contain}
                                                                                            resizeMode={"contain"}
                                                                                            _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}

                                                                                            //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                            uriComplete={item.image}
                                                                                            //source_image={item.image}
                                                                                            styleText={{marginTop: moderateScale(10)}}
                                                                                            borderRadius={4}/>
                                                                                )
                                                                        }
                                                                    </View>
                                                                    {
                                                                        item.count ?
                                                                            <View
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: 0,
                                                                                    right: 0,
                                                                                    backgroundColor: Colors.red,
                                                                                    height: moderateScale(30),
                                                                                    width: moderateScale(30),
                                                                                    borderRadius: moderateScale(15),
                                                                                    margin: moderateScale(4),
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center'
                                                                                }}>

                                                                                <HMTextView
                                                                                    numberOfLines={1}
                                                                                    type={"bold"}
                                                                                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                                                    text={item.count}

                                                                                    style={{
                                                                                        fontSize: moderateScale(10),

                                                                                        color: Colors.white,


                                                                                        //  textAlign: "right",
                                                                                    }}/>

                                                                            </View>
                                                                            :
                                                                            null
                                                                    }
                                                                </View>

                                                                <View style={{
                                                                    flex: .2,
                                                                    //backgroundColor: "#f4f4f4",
                                                                    backgroundColor: "#164A70",
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    borderTopColor: '#d0d8df',
                                                                    borderBottomColor: Colors.transparent,
                                                                    borderRightColor: Colors.transparent,
                                                                    borderLeftColor: Colors.transparent,
                                                                    borderWidth: moderateScale(1),
                                                                }}>
                                                                    <HMTextView
                                                                        numberOfLines={2}
                                                                        type={"bold"}
                                                                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                                        text={item.name}
                                                                        style={{
                                                                            fontSize: moderateScale(13),

                                                                            color: Colors.white,
                                                                            marginTop: moderateScale(4),
                                                                            //  textAlign: "right",
                                                                        }}/>
                                                                </View>


                                                            </TouchableOpacity>
                                                        ) //if you have a bunch of keys value pair

                                                    })
                                                    :
                                                    null

                                            }
                                        </View>
                                    </ScrollView>

                                //
                                // <FlatList
                                //     style={{marginTop: moderateScale(6)}}
                                //     // ItemSeparatorComponent={
                                //     //     <View style={{
                                //     //         width: '100%',
                                //     //         height: moderateScale(1),
                                //     //         backgroundColor: '#4f4f4f'
                                //     //     }}/>
                                //     // }
                                //     // data={comment === null || !comment ? [] : comment}
                                //     numColumns={this.state.columnCount}
                                //     key={this.state.columnCount}
                                //     //type => 1=  , 2= , 3= , 4= ,
                                //     data={checkLogin ? (resultsShahrdar.result.menu ? global.list_menu_shahrdar : []) : typeExport._NameApp == "Arak" ?
                                //         [
                                //             {
                                //                 name: 'ثبت درخواست',
                                //                 //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                //                 image_source: PathFile.image.sabt_darkhast,
                                //                 typeClick: 1,
                                //             },
                                //             {
                                //                 name: 'مشاهده نتیجه درخواست',
                                //                 //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                //                 image_source: PathFile.image.Natije_Darkhast,
                                //                 typeClick: 2,
                                //             },
                                //             {
                                //                 name: 'پیام به بازرسی',
                                //                 //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                //                 image_source: PathFile.image.Sabt_Shekayat,
                                //                 typeClick: 3,
                                //                 type: 7
                                //             },
                                //             {
                                //                 name: 'مشاهده نتیجه شکایات',
                                //                 //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                //                 image_source: PathFile.image.Natije_Shekayat,
                                //                 typeClick: 4,
                                //                 type: 7
                                //             },
                                //             // 1 === 1 ? {
                                //             //     name: 'کارتابل',
                                //             //     //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                //             //     image: PathFile.image.Natije_Shekayat,
                                //             //     typeClick: 5,
                                //             //     type: 7
                                //             // } : null
                                //             // ,
                                //         ]
                                //         : [
                                //             {
                                //                 name: 'ثبت درخواست',
                                //                 //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                //                 image_source: PathFile.image.sabt_darkhast,
                                //                 typeClick: 1,
                                //             },
                                //             {
                                //                 name: 'مشاهده نتیجه درخواست',
                                //                 //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                //                 image_source: PathFile.image.Natije_Darkhast,
                                //                 typeClick: 2,
                                //             },
                                //
                                //         ]
                                //
                                //     }
                                //     renderItem={this.renderItems}
                                //
                                //
                                // />
                                //
                                //

                            }

                            {
                                this.state.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                            }

                            {
                                checkLogin ?
                                    <DialogUpdateAppCustomize/>
                                    :
                                    null
                            }
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }


    goScreen(route, item, position) {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)

        container.setState({isLoading: false})
        NavigationService.navigateParams(route, {
            position: JSON.stringify(Tools.cloneAsObject(position)),
            //   position: JSON.stringify(position),
            //  position:position,
            typeComponent: checkLogin ? "Operation" : null,
            item: container.props.navigation && container.props.route && container.props.route.params ? container.props.route.params.item : JSON.stringify(item),
            data: JSON.stringify(item),
            type: route
        })
    }

    stateError() {
        container.setState({
            locationEnabled: false,
            isLoading: false,
        }, () => {
        })
    }

}
